"use strict"
exports.__esModule = true;
exports.PercentageIconConfig = {
  name: 'PercentageIcon',
  height: 512,
  width: 384,
  svgPath: 'M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z',
  yOffset: 0,
  xOffset: 0,
};
exports.PercentageIcon = require('../createIcon').createIcon(exports.PercentageIconConfig);
exports["default"] = exports.PercentageIcon;